import { React } from "react";
import { Card } from "antd";
import Slider from "react-slick";
import { LeagueSliderSettings } from "../config";

const tabs = [
  {
    name: "Premier League",
  },
  {
    name: "Spanish League",
  },
  {
    name: "Italian League",
  },
  {
    name: "Premier League",
  },
  {
    name: "Spanish League",
  },
  {
    name: "Italian League",
  },
];

const LeagueNavigation = () => {
  return (
    <Card style={{padding: 20, borderRadius: 10}}>
      <Slider {...LeagueSliderSettings}>
        <div></div>
        {tabs.map((item, index) => (
          <div key={index} className="text-center">
            <h3 className="text-2xl">{item.name}</h3>
          </div>
        ))}
      </Slider>
    </Card>
  );
};

export default LeagueNavigation;